module.exports = __webpack_public_path__ + "media/images/icons/external-link-324828bd27bdd84d2a6a72958e1c65bd.svg";